<template>
  <div class="clearfix">
    <div class="pull-left" style="width: 350px;">
      <el-card>
        <!-- <div class="mb-10">
          <el-input v-model.trim="searchAnything" placeholder="搜索员工或部门" @input="goSearching">
            <i
              slot="suffix"
              class="el-input__icon cur-pointer"
              :class="searchIcon"
              @click="clickSearchIcon"
            />
          </el-input>
        </div>-->
        <el-tree
          v-if="!isSearching"
          ref="deptTree"
          :data="deptList"
          :props="deptProps"
          node-key="ID"
          :highlight-current="true"
          :expand-on-click-node="false"
          :default-expanded-keys="[1]"
          :current-node-key="currentKey"
          @node-click="clickNode"
          :default-checked-keys="[1]"
        ></el-tree>
        <div v-else>
          <div v-if="searchedDeptList.length > 0">
            <div style="line-height: 30px;">部门列表：</div>
            <div
              v-for="(dept, index) in searchedDeptList"
              :key="index"
              class="searching-item"
              @click="selectSearchedDept(dept)"
            >
              <i class="fa fa-fw fa-vcard-o"></i>
              <span>{{ dept.Name }}</span>
            </div>
          </div>
          <div v-if="searchedMemberList.length > 0">
            <div style="line-height: 30px;">人员列表：</div>
            <div v-for="(member, index) in searchedMemberList" :key="index" class="searching-item">
              <div class="text-overflow">
                <i class="far fa-fw fa-user-circle" />
                <span>{{ member.Name }}</span>
                <span
                  :title="getSearchedMemberDept(member.ID).map(dept => dept.Name).join(', ')"
                >&nbsp;(&nbsp;{{ getSearchedMemberDept(member.ID).map(dept => dept.Name).join(', ') }}&nbsp;)</span>
              </div>
            </div>
          </div>
          <div
            v-if="searchedDeptList.length === 0 && searchedMemberList.length === 0"
            class="text-center"
            style="height: 80px; line-height: 80px; color: #5e7282;"
          >未搜索到相关部门或人员</div>
        </div>
      </el-card>
    </div>
    <div style="margin-left: 360px;">
      <show-data
        ref="showDetail"
        :dept-data="deptSelectedData"
        :dept-list="deptList"
        @refresh="refresh"
      ></show-data>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import * as _indexOf from 'lodash/indexOf';
import * as _cloneDeep from 'lodash/cloneDeep';
// import * as _find from 'lodash/find';
import ShowData from './show-data.vue';

export default {
  components: {
    ShowData,
  },
  data() {
    return {
      deptProps: {
        label: 'Name',
        children: 'Children',
      },
      // 部门结构列表
      deptList: [],
      // 树形控件item配置选项
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      // 选中部门信息
      deptSelectedData: {},
      expandedKeys: [],
      currentKey: '',
      // 绑定搜索input
      searchAnything: '',
      // 是否显示搜索结果
      isSearching: false,
      searchedDeptList: [],
      searchedMemberList: [],
      // 最终要高亮的值，以前高亮之后再拉数据没有关系，现在不行了，只能先拉数据再高亮
      lastKeyHighlight: '',
    };
  },
  computed: {
    searchIcon() {
      return this.searchAnything === '' ? 'el-icon-search' : 'el-icon-circle-close';
    },
  },
  watch: {
    deptList() {
      if (this.isSearching) {
        this.goSearching();
      }
    },
  },
  mounted() {
    this.getDeptList();
  },
  methods: {
    // 获取部门列表
    // 若array参数存在，则在获取到的数据中，找到array中最后一个数据对应id的数据
    // 若没有参数，则等于传入获取根目录的id
    getDeptList(deptDataId = undefined) {
      const params = {
        with: ['Members'],
        return_tree: 1,
      };
      this.$axios.get('department', { params })
        .then((response) => {
          this.deptList = _cloneDeep(response.data.data);
          if (deptDataId) {
            this.getDeptData(deptDataId);
          } else {
            this.selectDept(response.data.data[0]);
            this.expandedKeys = [response.data.data[0].ID];
            this.lastKeyHighlight = response.data.data[0].ID;
          }
          this.setCurrentKeySelf(this.lastKeyHighlight);
        }, (response) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 改变传入子组件数据
    selectDept(data) {
      this.deptSelectedData = data;
    },
    // 点击树形结构中的部门
    clickNode(data) {
      this.selectDept(data);
      this.expandedKeys = [data.id];
    },
    // 刷新部门树并选中传入节点
    refresh(key) {
      if (key) {
        // 重新获取指定id的节点数据
        this.getDeptList(key);
        this.expandedKeys = [key];
        this.lastKeyHighlight = key;
      } else {
        this.getDeptList();
        this.selectDept(this.deptList[0]);
      }
    },
    // input搜索
    goSearching() {
      // 防止频繁搜索
      if (this.debouncedQueryer) {
        this.debouncedQueryer.cancel();
      }
      this.debouncedQueryer = _.debounce(() => {
        if (this.searchAnything !== '') {
          this.isSearching = true;
          this.searchedDeptList = [];
          this.searchedMemberList = [];
          this.getMatchedDepts(this.deptList);
          this.getMatchedMembers(this.deptList);
        } else {
          // 如果搜索的是空字符串，则就是正常的树的显示，要有默认的高亮和当前节点显示，默认是第一个节点
          this.selectDept(this.deptList[0]);
          this.expandedKeys = [this.deptList[0].id];
          this.lastKeyHighlight = this.deptList[0].id;
          this.setCurrentKeySelf(this.lastKeyHighlight);
          this.isSearching = false;
        }
      }, 300);
      this.debouncedQueryer();
    },
    // input框的icon点击事件
    clickSearchIcon() {
      this.isSearching = false;
      this.searchAnything = '';
    },
    // 获取匹配搜索的部门
    getMatchedDepts(list) {
      list.forEach((dept) => {
        if (dept.name.includes(this.searchAnything)) {
          this.searchedDeptList.push(dept);
        }
        if (dept.children) {
          this.getMatchedDepts(dept.children);
        }
      });
    },
    // 获取匹配搜索的人员
    getMatchedMembers(list) {
      list.forEach((dept) => {
        const depts = this.searchedMemberList.map(member => member.id);
        dept.members.forEach((member) => {
          if (member.name.includes(this.searchAnything)
            && _indexOf(depts, member.id) === -1) {
            this.searchedMemberList.push(member);
          }
        });
        if (dept.children) {
          this.getMatchedMembers(dept.children);
        }
      });
    },
    // 点击搜索部门
    selectSearchedDept(data) {
      this.clickSearchIcon();
      this.clickNode(data);
      this.lastKeyHighlight = data.id;
      this.setCurrentKeySelf(this.lastKeyHighlight);
    },
    // 获取搜索过滤后成员所在的
    getSearchedMemberDept(id) {
      const depts = [];
      (
        (function getDeptName(list) {
          list.forEach((dept) => {
            if (_.find(dept.members, { id })) {
              depts.push({ name: dept.name, id: dept.id });
            }
            if (dept.children) {
              getDeptName(dept.children);
            }
          });
        })(this.deptList)
      );
      return depts;
    },
    // 手动设置currentKey
    setCurrentKeySelf(data) {
      this.$nextTick(() => {
        this.$refs.deptTree.setCurrentKey(data);
      });
    },
    getDeptData(did) {
      this.$axios.get(`department/${did}`, { params: { with: ['Members'] } })
        .then((response) => {
          this.selectDept(response.data);
        }, (response) => {
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.searching-item {
  padding: 0 10px;
  line-height: 24px;
  cursor: pointer;

  &:hover {
    background-color: #e4e7f1;

    .searching-item-buttons {
      display: block;
    }
  }
}
.searching-item-buttons {
  float: right;
  display: none;

  .el-button + .el-button {
    margin-left: 0;
  }
}
</style>
